<script setup>
import NavbarLightTagline from "~/components/navbar/NavbarLightTagline.vue";

const { t } = useI18n();

useHead({
  // Brand suffix appended to every non-home title. Localised via i18n
  // (seo.brandSuffix) so the geo-marker follows the page language —
  // "Batumi" / "Батуми" / "ბათუმი" — instead of a hardcoded EN toponym on
  // RU/KA pages. Batumi is the primary search term for the region; Chakvi
  // (the actual locality) stays in the address schema and body copy.
  // Read inside the function so it re-resolves on locale change.
  titleTemplate: (title) =>
    title ? `${title} ${t("seo.brandSuffix")}` : t("seo.fallbackTitle"),
  bodyAttrs: {
    class: "dark:bg-slate-900",
  },
});
</script>

<template>
  <main>
    <NavbarTagline />
    <NavbarLightTagline />
    <slot />
    <BackToTop />
    <PartialsFooter />
  </main>
</template>
